<template>
    <div class="result-page">
        <b-row class="row-heading">
            <div class="col-back">
                <h1>
                    <b-link :to="{name: 'tests_active'}">
                        <em class="icon-chevron-down left"></em>
                    </b-link>
                    <span v-html="$t('tests.results.test_results')"></span>
                </h1>
            </div>
            <div class="col-progress">
                <span class="state state-progress" v-if="test.status === 'active'"><em class="icon-inprogress"></em>{{$t('tests.statuses.in_progress')}}</span>
                <span class="state state-completed" v-if="test.status === 'completed'"><em class="icon-completed"></em>{{$t('tests.statuses.completed')}}</span>
                <b-progress :value="test.progress" variant="primary" class="d-inline-flex"></b-progress>
                <span class="text-progress">{{test.progress}}%</span>
            </div>
            <div class="col-options">
                <span class="text-options">
                     <em class="icon-country"></em>
                    <span v-if="test.language_countries_id">{{ getCountryLanguage(test) }}</span>
                    <span v-else v-html="$t('tests.custom_value')"></span>
                </span>
                <span class="text-options">
                     <em class="icon-yearsold"></em>
                    <span v-if="test.testers_cnt">{{ test.testers_cnt }}</span>
                    <span v-else v-html="$t('tests.custom_value')"></span>
                </span>
            </div>
        </b-row>
        <b-row class="row-tabs">
            <b-col cols="12">
                <span class="title">{{$t('tests.results.select_area')}}</span>
                <b-tabs>
                    <template v-slot:tabs-end>
                        <b-nav-item v-for="area in test.areas" :key="area.id" role="presentation"
                                    @click="switchArea(area.uuid)" :active="activeAreaId === area.uuid">
                            {{$t('tests.area', {i:area.index})}}
                        </b-nav-item>
                        <b-nav-item role="presentation"
                                    @click="switchArea('general')" :active="activeAreaId === 'general'">
                            {{$t('tests.results.followup')}}
                        </b-nav-item>
                    </template>
                </b-tabs>
                <a href="javascript:;" @click="exportToExcel" class="link-export">{{$t('tests.results.export_answers')}}</a>
            </b-col>
        </b-row>
        <b-row class="row-tabs-content">
            <b-col cols="12" md="4">
                <question-image
                    :currentArea="test.preview_areas ? test.preview_areas : test.areas"
                    :image="(test.images && test.images.preview) ? test.images.preview : test.image_url"
                    :originalImage="test.images.original ? test.images.original : test.image_url"
                    v-if="activeAreaId === 'general'"
                ></question-image>
                <question-image
                    :currentArea="activeArea"
                    :image="(test.images && test.images.preview) ? test.images.preview : test.image_url"
                    :originalImage="test.images.original ? test.images.original : test.image_url"
                    v-else
                ></question-image>
            </b-col>
            <b-col cols="12" md="8">
                <div role="tablist" :key="activeAreaId">
                    <b-card no-body
                            v-for="question in (activeAreaId === 'general' ? generalQuestions : areaQuestions)"
                            :key="question.id">
                        <b-card-header header-tag="header" role="tab">
                            <b-button block v-b-toggle="'question-' + question.id" variant="accordion-opener">
                                {{question.question}}
                                <em class="icon-chevron-down"></em>
                            </b-button>
                        </b-card-header>
                        <b-collapse :id="'question-' + question.id" visible accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <ul class="testers_results_answers_filters" v-if="question.answer_type !== 'radio' && orderedAnswers(question.id)">
                                    <li>
                                        <a href="javascript:;"
                                           @click="likeOnTop(question.id)">
                                            <span v-if="likeOnTopOrder == question.id">{{$t('tests.normal_order')}}</span>
                                            <span v-else>{{$t('tests.liked_on_top')}}</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="javascript:;"
                                            @click="showAnswer(question.id)">
                                            <span v-if="hidenAnswer == question.id">{{$t('tests.hide_hidden_answers')}}</span>
                                            <span v-else>{{$t('tests.show_hidden_answers')}}</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="javascript:;"
                                           @click="expandAll(question.id)">
                                            <span v-if="expandItem === question.id" v-html="$t('tests.collapse_all_answers')"></span>
                                            <span v-else v-html="$t('tests.expand_all_answers')"></span>
                                        </a>
                                    </li>
                                </ul>
                                <div class="testers_results_answers_wrapper" v-if="orderedAnswers(question.id)" :class="[expandItem === question.id ? 'expand-all' : '', question.answer_type === 'radio' ? 'radio-wrap' : '', hidenAnswer == question.id ? 'unhide-all' : '']">
                                    <b-card v-if="question.answer_type === 'radio'" class="card-summary">
                                        <b-card-header class="d-flex justify-content-between">
                                            <span class="title" v-html="$t('tests.summary_result_title')"></span>
                                            <a href="javascript:;"
                                               @click="expandAll(question.id)">
                                                <span v-html="$t('tests.collapse_all_answers')" v-if="expandItem === question.id"></span>
                                                <span v-html="$t('tests.expand_all_answers')" v-else></span>
                                            </a>
                                        </b-card-header>
                                        <b-card-body>
                                            <div class="graph-holder">
                                                <apexbar :height="'auto'" barType="pie" :barColor="['#454545','#454545','#454545','#454545','#454545']" :categories="category(question.id, question)" :barColors="['#3636ff','#3636ff','#3636ff','#3636ff','#3636ff']" barName="community" barHeight="340"></apexbar>
                                            </div>
                                        </b-card-body>
                                    </b-card>
                                    <b-card v-for="(answer, i) in orderedAnswers(question.id)" :key="answer.id" :class="{'hidden': answer.is_hidden && !hidenAnswer}">
                                        <b-card-header>
                                            #{{i + 1}} {{_.capitalize(answer.tester.name)}} (
                                            {{$t('tests.years_old_short', {years:answer.tester.age})}} )
                                        </b-card-header>

                                        <b-card-body v-if="question.answer_type === 'radio'">
                                            <span class="radio-checked">{{answer.answer}}</span>
                                        </b-card-body>

                                        <b-card-body v-else>
                                            <p>{{answer.answer}}</p>
                                        </b-card-body>

                                        <b-card-footer v-if="question.answer_type !== 'radio'" class="test-results-item-footer">
                                            <span @click="toggleAnswerLike(answer.id)" class="like">
                                                <span v-if="answer.is_liked">
                                                    <em class="icon-unlike"></em>
                                                    {{$t('tests.unlike')}}
                                                </span>
                                                <span v-else>
                                                    <em class="icon-like"></em>
                                                    {{$t('tests.like')}}
                                                </span>
                                            </span>
                                            <span @click="toggleAnswerHide(answer.id)" class="hide">
                                                <span v-if="answer.is_hidden">
                                                    <em class="icon-unhide"></em>
                                                    {{$t('tests.unhide')}}
                                                </span>
                                                <span v-else>
                                                    <em class="icon-hide"></em>
                                                    {{$t('tests.hide')}}
                                                </span>
                                            </span>
                                        </b-card-footer>
                                    </b-card>
                                </div>
								<span class="answer-zero-state" v-html="$t('tests.empty_answers')" v-else></span>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
            </b-col>
        </b-row>
    </div>

</template>

<script>
    import {mapGetters, mapMutations, mapActions} from 'vuex';

    export default {
        props: ['test_id'],
        name: 'test-results',
        beforeRouteEnter(to, from, next) {
            return Promise.all([
                window._store.dispatch('tests/show', to.params.testId),
                window._store.dispatch('options/loadQuestions', to.params.testId),
                window._store.dispatch('tests/loadTestAnswers', to.params.testId),
                window._store.dispatch('options/loadCountryLanguageOptions'),
            ]).then(next).catch(e => {
                // [Nick] TODO: Add errors handling
                return next({
                    name: 'tests_active'
                });
            });
        },
        beforeRouteUpdate(to, from, next) {
            window._store.dispatch('tests/show', to.params.testId).then(next).catch(e => {
                // [Nick] TODO: Add errors handling
                return next({
                    name: 'tests_active'
                });
            });
        },
        data() {
            return {
                activeAreaId: null,
                x: 'a',
                expandItem: null,
                likeOnTopOrder: null,
                hidenAnswer: null,
            }
        },
        computed: {
            activeArea() {
                if (!this.activeAreaId) {
                    this.activeAreaId = _.first(this.test.areas).uuid;
                }
                return _.find(this.test.areas, area => this.activeAreaId === area.uuid);
            },
            ...mapGetters({
                test: 'tests/getCurrentTest',
                questions: 'options/questions',
                answers: 'tests/currentTestAnswers',
                countryLanguageOptions: 'options/countryLanguageOptions',
            }),
            areaQuestions() {
                return _.filter(this.questions, question => !question.is_general);
            },
            generalQuestions() {
                return _.filter(this.questions, question => question.is_general);
            },
            activeAreaAnswers() {
                const groupedAnswers = {};
                if (this.activeAreaId) {
                    _(this.answers).filter(answer => answer.area_uuid === this.activeAreaId).each(answer => {
                        if (!groupedAnswers.hasOwnProperty(answer.question_id)) {
                            groupedAnswers[answer.question_id] = [];
                        }
                        groupedAnswers[answer.question_id].push(answer);
                    });
                }

                return groupedAnswers;
            },
        },
        methods: {
            switchArea(areaId) {
                this.activeAreaId = areaId;
            },
            expandAll(i) {
                if (this.expandItem !== i) {
                    this.expandItem = i;
                }
                else {
                    this.expandItem = null;
                }
            },
            category(e, q) {
                let totalAnswers = 0;
                let apexContent = [];
                let answer = this.activeAreaAnswers[e];
                let totalContent = {
                    value: [],
                    name: [],
                    color: [],
                };
                for (let i = 0; q.answers.length > i; i++) {
                    apexContent.push({name: q.answers[i].answer, value: 0});
                    totalContent.name.push(apexContent[i].name);
                }
                if (answer) {
                    for (let i = 0; answer.length > i; i++) {
                        let currentAnswer = apexContent.find(x => x.name === answer[i].answer);
                        if(!currentAnswer) {
                            apexContent.push({name: answer[i].answer, value: 0});
                        }
                        apexContent.find(x => x.name === answer[i].answer).value++;
                        totalAnswers++;
                    }
                }
                for (let i = 0; apexContent.length > i; i++) {
                    let textColor = '#ffffff';
                    if (apexContent[i].value > 0) {
                        apexContent[i].value = Math.round((apexContent[i].value * 100 / totalAnswers) * 100) / 100;
                    }
                    totalContent.value.push(apexContent[i].value);
                    if (apexContent[i].value < 10) {
                        textColor = '#000000';
                    }
                    totalContent.color.push(textColor);
                }
                return totalContent;
            },
            toggleAnswerLike(answerId) {
                this.$store.dispatch('tests/toggleAnswerLike', answerId);
            },
            toggleAnswerHide(answerId) {
                this.$store.dispatch('tests/toggleAnswerHide', answerId);
            },
            likeOnTop(questionId){
                if(this.likeOnTopOrder !== questionId){
                    this.likeOnTopOrder = questionId;
                }else{
                    this.likeOnTopOrder = null;
                }
            },
            showAnswer(questionId){
                if(this.hidenAnswer !== questionId){
                    this.hidenAnswer = questionId;
                }else{
                    this.hidenAnswer = null;
                }
            },
            orderedAnswers(questionId){
                let answer = this.activeAreaAnswers[questionId];
                if(this.likeOnTopOrder && this.likeOnTopOrder === questionId){
                    return _.orderBy(answer, 'is_liked', 'desc');
                }else{
                    return answer;
                }
            },
			getCountryLanguage(test) {
				let option =  _.find(this.countryLanguageOptions, option => option.id === test.language_countries_id);
				return option ? option.language : '---';
			},
			getTesterAge(test) {
				let option =  _.find(this.testerAgeOptions, option => option.id === test.age_ranges_id);
				return option ? option.label : '---';
			},

            /**
             * Generate excel file on API and download.
             */
            exportToExcel() {
                axios.post(`${process.env.MIX_API_PREFIX}test/${this.test.id}/export`, {
                    locale: this.$i18n.locale
                }).then(response => {
                    let link = document.createElement('a');
                    link.href = response.data.download;
                    link.download = response.data.name;
                    document.body.appendChild(link);
                    link.click();
                }).catch(error => {
                    if (error?.data?.message) {
                        this.pushNotification(error.data.message, 'danger');
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>
